import { MappedClass, MappedProperty, MappedPropertyCurrency } from '@h5s/util-object';
import Big from 'big.js';
import { Stay } from './stay';

export interface UpdateStayFields {
  available: boolean;
  basePrice?: Big | null;
  costCenterId?: number | null;
  defaultPriceListId?: number | null;
  departmentId?: number | null;
  description: string;
  descriptionDe?: string | null;
  descriptionEn?: string | null;
  descriptionEs?: string | null;
  descriptionFr?: string | null;
  exportCode?: string | null;
  id: number;
  notes?: string | null;
  notesDe?: string | null;
  notesEn?: string | null;
  notesEs?: string | null;
  notesFr?: string | null;
  priceLists?: number[] | null;
  vat?: Big | null;
  vatRateId?: number | null;
  addedBedFixed: boolean;
  addedJuniorBedFixed: boolean;
  ageAddedCradle?: number | null;
  ageAddedJuniorBed?: number | null;
  breakfast: boolean;
  channelManagerCode?: string | null;
  channelManagerPriceListId?: number | null;
  dinner: boolean;
  endpointCode?: string | null;
  extraBreakfast?: Big | null;
  extraDinner?: Big | null;
  extraLunch?: Big | null;
  lunch: boolean;
  maxNumberOfGuests: number;
  maxPrice?: Big | null;
  minPrice?: Big | null;
  numberOfGuests?: number | null;
  onlyOta: boolean;
  priceAddedBed?: Big | null;
  priceAddedCradle?: Big | null;
  priceAddedJuniorBed?: Big | null;
  rateManagerCode?: string | null;
  realStayId?: number | null;
  shortDescription?: string | null;
  virtual: boolean;
  webOrder?: number | null;
}

@MappedClass()
export class UpdateStay implements UpdateStayFields {
  @MappedProperty()
  available: boolean;

  @MappedPropertyCurrency()
  basePrice?: Big | null;

  @MappedProperty()
  costCenterId?: number | null;

  @MappedProperty()
  defaultPriceListId?: number | null;

  @MappedProperty()
  departmentId?: number | null;

  @MappedProperty()
  description: string;

  @MappedProperty()
  descriptionDe?: string | null;

  @MappedProperty()
  descriptionEn?: string | null;

  @MappedProperty()
  descriptionEs?: string | null;

  @MappedProperty()
  descriptionFr?: string | null;

  @MappedProperty()
  exportCode?: string | null;

  @MappedProperty()
  id: number;

  @MappedProperty()
  notes?: string | null;

  @MappedProperty()
  notesDe?: string | null;

  @MappedProperty()
  notesEn?: string | null;

  @MappedProperty()
  notesEs?: string | null;

  @MappedProperty()
  notesFr?: string | null;

  @MappedProperty()
  priceLists?: number[] | null;

  @MappedPropertyCurrency()
  vat?: Big | null;

  @MappedProperty()
  vatRateId?: number | null;

  @MappedProperty()
  addedBedFixed: boolean;

  @MappedProperty()
  addedJuniorBedFixed: boolean;

  @MappedProperty()
  ageAddedCradle?: number | null;

  @MappedProperty()
  ageAddedJuniorBed?: number | null;

  @MappedProperty()
  breakfast: boolean;

  @MappedProperty()
  channelManagerCode?: string | null;

  @MappedProperty()
  channelManagerPriceListId?: number | null;

  @MappedProperty()
  dinner: boolean;

  @MappedProperty()
  endpointCode?: string | null;

  @MappedPropertyCurrency()
  extraBreakfast?: Big | null;

  @MappedPropertyCurrency()
  extraDinner?: Big | null;

  @MappedPropertyCurrency()
  extraLunch?: Big | null;

  @MappedProperty()
  lunch: boolean;

  @MappedProperty()
  maxNumberOfGuests: number;

  @MappedPropertyCurrency()
  maxPrice?: Big | null;

  @MappedPropertyCurrency()
  minPrice?: Big | null;

  @MappedProperty()
  numberOfGuests?: number | null;

  @MappedProperty()
  onlyOta: boolean;

  @MappedPropertyCurrency()
  priceAddedBed?: Big | null;

  @MappedPropertyCurrency()
  priceAddedCradle?: Big | null;

  @MappedPropertyCurrency()
  priceAddedJuniorBed?: Big | null;

  @MappedProperty()
  rateManagerCode?: string | null;

  @MappedProperty()
  realStayId?: number | null;

  @MappedProperty()
  shortDescription?: string | null;

  @MappedProperty()
  virtual: boolean;

  @MappedProperty()
  webOrder?: number | null;

  constructor(fields?: UpdateStayFields) {
    Object.assign(this, fields);
  }

  public static fromStay(data: Stay): UpdateStay {
    return new UpdateStay({
      available: data.available,
      basePrice: data.basePrice ?? null,
      costCenterId: data.costCenterId ?? null,
      defaultPriceListId: data.defaultPriceListId ?? null,
      departmentId: data.departmentId ?? null,
      description: data.description,
      descriptionDe: data.descriptionDe ?? null,
      descriptionEn: data.descriptionEn ?? null,
      descriptionEs: data.descriptionEs ?? null,
      descriptionFr: data.descriptionFr ?? null,
      exportCode: data.exportCode ?? null,
      id: data.id,
      notes: data.notes ?? null,
      notesDe: data.notesDe ?? null,
      notesEn: data.notesEn ?? null,
      notesEs: data.notesEs ?? null,
      notesFr: data.notesFr ?? null,
      priceLists: data.priceLists.map((p) => p.id),
      vat: data.vat ?? null,
      vatRateId: data.vatRateId ?? null,
      addedBedFixed: data.addedBedFixed,
      addedJuniorBedFixed: data.addedJuniorBedFixed,
      ageAddedCradle: data.ageAddedCradle ?? null,
      ageAddedJuniorBed: data.ageAddedJuniorBed ?? null,
      breakfast: data.breakfast,
      channelManagerCode: data.channelManagerCode ?? null,
      channelManagerPriceListId: data.channelManagerPriceListId ?? null,
      dinner: data.dinner,
      endpointCode: data.endpointCode ?? null,
      extraBreakfast: data.extraBreakfast ?? null,
      extraDinner: data.extraDinner ?? null,
      extraLunch: data.extraLunch ?? null,
      lunch: data.lunch,
      maxNumberOfGuests: data.maxNumberOfGuests,
      maxPrice: data.maxPrice ?? null,
      minPrice: data.minPrice ?? null,
      numberOfGuests: data.numberOfGuests ?? null,
      onlyOta: data.onlyOta,
      priceAddedBed: data.priceAddedBed ?? null,
      priceAddedCradle: data.priceAddedCradle ?? null,
      priceAddedJuniorBed: data.priceAddedJuniorBed ?? null,
      rateManagerCode: data.rateManagerCode ?? null,
      realStayId: data.realStayId ?? null,
      shortDescription: data.shortDescription ?? null,
      virtual: data.virtual,
      webOrder: data.webOrder ?? null,
    });
  }
}
